import { IApplicationState } from '../../../../types/types';
import { getAuthUser } from './getAuthUser';

const SPLIT_SETTING_RELEASE_DATE = 0;//Было 1727416800

export const getUserShowSplitSettings = (
    state: IApplicationState
): boolean => {
    const user = getAuthUser(state);
    return user && user.createDateTimeStamp && user.createDateTimeStamp > SPLIT_SETTING_RELEASE_DATE;
};
